import { observer } from 'mobx-react';
import * as React from 'react';
import { Button, Modal, Box, Typography, Grid } from '@mui/material';
import HomePageStore from '../store/HomePageStore';
import CloseIcon from '../../../assets/image/close.png';
import { useMediaQueryState } from '../../../hooks/useMediaQueryState';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '15px',
  paddingTop: '30px',
  paddingBottom: '20px',
  paddingLeft: '20px',
  paddingRight: '20px',
  minWidth: '90vw',
};
interface Props {
  pageStore: HomePageStore;
}
function HomePageListModal(props: Props) {
  const { pageStore } = props;
  const { isPC } = useMediaQueryState();

  const handleClose = () => {
    pageStore.setIsOpenModal(false);
  };

  return (
    <Modal open={pageStore.isOpenModal} onClose={handleClose} aria-labelledby='modal-title' aria-describedby='modal-description'>
      <Box sx={{ ...style, ...(isPC ? { width: 600, textAlign: 'center' } : {}) }}>
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontWeight: 500,
            fontSize: '18px',
            lineHeight: '18px',
            textAlign: 'center',
            marginBottom: '30px',
          }}
        >
          Objectives & Targets
        </Typography>
        <Grid>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: '14px',
              lineHeight: '14px',
              color: '#212121',
              marginBottom: '12px',
            }}
          >
            분기 목표
          </Typography>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: '14px',
              lineHeight: '20px',
              color: '#6C6B6F',
            }}
          >
            {pageStore.currentUser.userData.quarterGoal}
          </Typography>
        </Grid>
        <Grid>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: '14px',
              lineHeight: '14px',
              color: '#212121',
              marginTop: '24px',
              marginBottom: '12px',
            }}
          >
            반기 목표
          </Typography>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: '14px',
              lineHeight: '20px',
              color: '#6C6B6F',
              marginBottom: '30px',
            }}
          >
            {pageStore.currentUser.userData.semiAnnualGoal}
          </Typography>
        </Grid>
        <Button
          sx={{
            width: '100%',
            background: '#2281D0',
            borderRadius: '25px',
            color: '#ffffff',
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '16px',
            padding: '17px 132px',
          }}
          variant='contained'
          onClick={handleClose}
        >
          OK
        </Button>
        <img src={CloseIcon} style={{ position: 'absolute', right: '18px', top: '18px', cursor: 'pointer' }} onClick={handleClose} alt='closeIcon' />
      </Box>
    </Modal>
  );
}

export default observer(HomePageListModal);
